module.exports = __webpack_public_path__ + "img/school-members-home.280dce3c.jpg";